import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-600 py-4">
      {items.map((item, index) => (
        <span key={index} className="flex items-center">
          {index > 0 && (
            <i className="ri-arrow-right-s-line mx-2 text-foreground-400"></i>
          )}
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-primary-500 transition-colors duration-200"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}